'use strict';

angular.module('clientDashboardApp').controller("ListingEditorCtrl",
  function ($scope, $log, $uibModalInstance, listingOptions, listingService) {
    var states = {
      LoadingData: 'LoadingData',
      UserEditing: 'UserEditing',
      EditListingURL: 'EditListingURL',
      PendingFixedURL: 'PendingFixedURL',
      EditingListingBusinessId: 'EditingListingBusinessId',
      PendingConfirmation: 'PendingConfirmation',
      Success: 'Success',
      Error: 'Error'
    };
    $scope.state = states.LoadingData;

    var handleListingEditorInfo = function (listingEditorInfo, providerService) {
      $scope.listingEditorInfo = listingEditorInfo;
      $scope.shouldShowEditButton = () => {
        return providerService.getProvider(listingOptions.provider).displaySettings.displaysListingUrl
      }

      //Fixed URL
      $scope.exampleURL = listingEditorInfo.exampleURL;

      //some providers don't support manual entry of fixed url
      $scope.supportsEditFixedUrl = listingEditorInfo.supportsEditFixedUrl
      //Some providers may not have validators so only apply if one exists
      if (listingEditorInfo.validationRegex) {
        $scope.validationRegex = new RegExp(listingEditorInfo.validationRegex);
      } else {
        //Provide default regex for URLs if no specific regex is provided
        $scope.validationRegex = /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
        //we are temporarily disabling providers without specific urls/validations
      }

      $scope.hasListing = listingEditorInfo.bestListing || listingEditorInfo.fixedURL;
      //Having a pending url takes priority
      if (!$scope.hasListing && listingEditorInfo.supportsListingBusinessId) {
        $scope.editor = {
          listingBusinessId: listingEditorInfo.listingBusinessId
        };
        $scope.state = states.EditingListingBusinessId;
      } else if (listingEditorInfo.bestListing) {
        //Best Listing
        $scope.bestListing = listingEditorInfo.bestListing;
        $scope.duplicateListings = listingEditorInfo.duplicateListings;
        $scope.urlControl.selectedURL = listingEditorInfo.fixedURL && listingEditorInfo.fixedURL.listingURL;
        $scope.state = states.UserEditing;
      } else if (listingEditorInfo.fixedURL && listingEditorInfo.fixedURL.listingURL) {
        $scope.pendingFixedURL = listingEditorInfo.fixedURL;
        $scope.urlControl.selectedURL = listingEditorInfo.fixedURL.listingURL;
        $scope.state = states.PendingFixedURL;
      } else {
        //Location has no crawled or fixed listings
        $scope.state = states.EditListingURL;
      }
    };

    $scope.urlControl = {selectedURL: ""};
    $scope.contentProvider = listingOptions.provider;
    listingService.listingFixedURLInfo(listingOptions.locationId, listingOptions.provider).then(handleListingEditorInfo);

    $scope.editUrl = function () {
      $scope.state = states.EditListingURL;
    };

    $scope.cancelUrlUpdate = function () {
      handleListingEditorInfo($scope.listingEditorInfo);
    };

    $scope.addListingBusinessIdAction = function(validForm) {
      if (!validForm) {
        return;
      }
      //Selected URL

      //Send to server side
      $scope.state = states.PendingConfirmation;
      //Change state until response received.
      var createListingReq = {
        locationId: listingOptions.locationId,
        provider: listingOptions.provider,
        listingBusinessId: $scope.editor.listingBusinessId
      };
      listingService.updateFixedURL(createListingReq).then(
        function () {
          $scope.state = states.Success;
        },
        function () {
          $scope.state = states.Error;
        });
    };

    $scope.addUrlAction = function AddUrl(validForm) {
      if (!validForm) {
        return;
      }
      //Selected URL

      //Send to server side
      $scope.state = states.PendingConfirmation;
      //Change state until response received.
      var createListingReq = {
        locationId: listingOptions.locationId,
        provider: listingOptions.provider,
        url: $scope.urlControl.selectedURL
      };

      listingService.updateFixedURL(createListingReq).then(
        result => {
            $scope.state = states.Success;
            $scope.errorType = "";
        },
        result => {
            $scope.errorType = !!result.data.error.message && result.data.error.message.errorType;
            $scope.locationIdWithUrl = !!result.data.error.message && result.data.error.message.locationIdWithUrl;
            $scope.state = states.Error;
        });
    };

    $scope.markListingPrimary = function MarkListingPrimary(listing) {
      $scope.state = states.PendingConfirmation;
      listingService.markListingPrimary(listing.listingId).then(function () {
          //Successfully removed
          $scope.state = states.Success;
        },
        function () {
          $scope.state = states.Error;
        });
    };

    $scope.removeDuplicateListing = function RemoveDuplicateListing(listing) {
      listing.status = 'pendingDeletion';
      listingService.removeListing(listing.listingId).then(function () {
          //Successfully removed
          listing.status = 'deleted';
        },
        function () {
          listing.status = 'error';
        });
    };

    $scope.removePrimaryListing = function RemovePrimaryListing(listing) {
      $scope.state = states.PendingConfirmation;
      listingService.removeListing(listing.listingId).then(function () {
          //Successfully removed
          $scope.state = states.Success;
        },
        function () {
          $scope.state = states.Error;
        });
    };

    $scope.close = function () {
      $uibModalInstance.dismiss('cancel');
    };
  });
